export const formatPhone = (phoneStr: string) => {
  const value = phoneStr.replace(/\D/g, '');

  if (value.length > 12) {
    return value.replace(/(\d{2})?(\d{2})?(\d{5})?(\d{4})/, '+$1 ($2) $3-$4');
  } else if (value.length > 11) {
    return value.replace(/(\d{2})?(\d{2})?(\d{4})?(\d{4})/, '+$1 ($2) $3-$4');
  } else if (value.length > 10) {
    return value.replace(/(\d{2})?(\d{5})?(\d{4})/, '($1) $2-$3');
  } else if (value.length > 9) {
    return value.replace(/(\d{2})?(\d{4})?(\d{4})/, '($1) $2-$3');
  } else if (value.length > 5) {
    return value.replace(/^(\d{2})?(\d{4})?(\d{0,4})/, '($1) $2-$3');
  } else if (value.length > 1) {
    return value.replace(/^(\d{2})?(\d{0,5})/, '($1) $2');
  } else {
    return value.replace(/^(\d*)/, '($1');
  }
};
